import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'

export interface UIButtonDangerProps extends
  Omit<UIButtonProps, 'variant'> {
}

/**
 * Danger Button Component
 * Based on official shadcn button block with destructive variant
 * Use for dangerous actions like delete, reset, remove
 */
export const UIButtonDanger = React.forwardRef<HTMLButtonElement, UIButtonDangerProps>(
  (props, ref) => {
    return (
      <UIButton
        variant="destructive"
        ref={ref}
        {...props}
      />
    )
  }
)

UIButtonDanger.displayName = "UIButtonDanger"